import { Skeleton } from '@workspace/ui/components/skeleton';
export const LoadingCard = () => {
  return (
    <div className="w-full h-full">
      <Skeleton className="w-1/2 h-1/2 rounded-xl" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-[250px]" />
        <Skeleton className="h-4 w-[200px]" />
      </div>
    </div>
  );
}
